import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxWrapperStyled = styled(Box)({
  cursor: 'pointer',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ContentStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});
